<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class BaseLayout extends Vue {
        drawer = false
        restored = false
    }

    export default BaseLayout
</script>
